import {linkFragmentToHref} from '@/modules/foundation/sanity/link/query';

import type {FooterProps} from '../../components/Footer';
import type {SiteSettingsFragment} from '../query';

export const footerPropsFromSiteSettingsFragment = (
	siteSettings: SiteSettingsFragment,
): FooterProps => {
	const {contactInfo, socialMedia, footerLinks} = siteSettings;

	return {
		organization: {
			address: contactInfo?.address,
			phoneNumber: contactInfo?.phoneNumber,
			email: contactInfo?.email,
		},
		socialMediaLinks: socialMedia?.map((link) => ({
			_key: link._key,
			href: link.url,
			title: link.title,
			targetBlank: true,
		})),
		links: footerLinks?.map((link) => ({
			_key: link._key,
			href: linkFragmentToHref(link),
			title: link.title,
			targetBlank: link.targetBlank,
		})),
	};
};
